import {
  GET_HISTORYSTATUS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  CREATE_HISTORYSTATUS,
  DELETE_HISTORYSTATUS,
} from './actionType';

const INIT_STATE = {
  historyStatus: [],
  error: {},
  success: '',
};

const HistoryStatus = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_HISTORYSTATUS:
          return {
            ...state,
            historyStatus: action.payload.data,
            success: 'Successfully get created',
            error: {},
          };
        case CREATE_HISTORYSTATUS:
          return {
            ...state,
            success: 'Successfully created',
            error: {},
          };
        case DELETE_HISTORYSTATUS:
          return {
            ...state,
            success: 'Successfully Deleted',
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_HISTORYSTATUS:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case CREATE_HISTORYSTATUS:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case DELETE_HISTORYSTATUS:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_HISTORYSTATUS: {
      return {
        ...state,
      };
    }
    case CREATE_HISTORYSTATUS: {
      return {
        ...state,
      };
    }
    case DELETE_HISTORYSTATUS:
      return {
        ...state,
      };
    default:
      return { ...state };
  }
};

export default HistoryStatus;
